<script>
import {reservation} from '../stores/reservation-store';
import {
    i18n,
} from "svelte-translate";
</script>
<table class="Form-table">
    <tr class="Form-table-row">
        <th scope="row" class="Form-table-label" use:i18n={"eventTypeLabel"}>Event type:</th>
        <td class="Form-table-data">{$reservation.readableEventTypeName}</td>
    </tr>
    <tr class="Form-table-row">
        <th scope="row" class="Form-table-label" use:i18n={"parkLabel"}>Park</th>
        <td class="Form-table-data">{$reservation.readableParkName}</td>
    </tr>
    <tr class="Form-table-row">
        <th scope="row" class="Form-table-label" use:i18n={"dateLabel"}>Date</th>
        <td class="Form-table-data">{$reservation.readableJumpDate}</td>
    </tr>
    <tr class="Form-table-row">
        <th scope="row" class="Form-table-label" use:i18n={"jumperCountLabel"}>Jumpers</th>
        <td class="Form-table-data">{$reservation.numJumpers}</td>
    </tr>
    <tr class="Form-table-row">
        <th scope="row" class="Form-table-label" use:i18n={"timeLabel"}>Time</th>
        <td class="Form-table-data">{#if $reservation.timeSlot}{$reservation.timeSlot}:00 - {$reservation.timeSlot + parseInt($reservation.duration,10)}:00{:else}<span class="text-kj-blue">Select time</span>{/if}</td>
    </tr>
    {#if $reservation.celebrants[0]['name'] !== ''}
    {#each $reservation.celebrants as celebrant}
        <tr class="Form-table-row">
            <th scope="row" class="Form-table-label" use:i18n={"celebrantLabel"}>Person celebrating</th>
            <td class="Form-table-data">{celebrant.name} / {celebrant.age} / {celebrant.gender}</td>
        </tr>
    {/each}
    {/if}
</table>
